export default "__VITE_ASSET__DZEpYPRd__"